import React from "react";

/**
 * @type {import("react").Context<import("customHooks/useBankTransfers/types").ReturnBankTransfer>}
 */
const accountComboContext = React.createContext();

export default accountComboContext;
